import {
  composeClassNames,
  ifDefined,
  withDefault,
} from "@faedev/editor-utils";
import { match } from "@faedev/variant";
import { useRouter } from "next/router";
import Content from "src/components/Content";
import ContentProperties from "src/components/ContentProperties";
import Footer from "src/components/Footer";
import Footers from "src/components/Footers";
import Header from "src/components/Header";
import Headers from "src/components/Headers";
import InstructorHighlight from "src/components/InstructorHighlight";
import Page from "src/components/Page";
import PlaylistHead from "src/components/PlaylistHead";
import PlaylistIntroduction from "src/components/PlaylistIntroduction";
import Preloader from "src/components/Preloader";
import ValidateContent from "src/components/ValidateContent";
import VideoListPlaylist from "src/components/VideoListPlaylist";
import constants from "src/constants";
import defaultThumbnail from "src/functions/defaultThumbnail";
import getData from "src/functions/getData";
import getOg from "src/functions/getOg";
import { mapContentToVideoCards } from "src/functions/mapContentToVideoCards";
import translate from "src/functions/translate";
import { sPageSerie } from "src/styles/sPageSerie.module.scss";
import { ApiLectureNested } from "src/types/ApiLectureNested";

export default function Playlist(props) {
  const { ["static"]: _static } = props;
  var { locale: lang, isFallback, query, asPath } = useRouter();
  const slug = props.slug || query.slug || asPath.split("/")[2];

  const originalData = getData("playlists", slug, lang, true).data;
  // const freshDataLoaded = originalData[0] === "success";
  var dPlaylist = match(
    originalData,
    {
      loading: function () {
        return isFallback ? null : _static;
      },
      error: function () {
        return null;
      },
      success: function (success) {
        return success;
      },
    },
    function (type) {
      return null;
    }
  );

  var playlistTitle = dPlaylist
    ? dPlaylist.title
    : translate(constants.Marketing.ogTitle, lang);
  var playlistLabel = dPlaylist
    ? dPlaylist.label
    : translate(constants.Marketing.ogDescription, lang);
  var lectures = dPlaylist
    ? dPlaylist.lectures.filter((lecture: ApiLectureNested) => lecture.paid)
    : [];

  const ogData = getOg(
    lang,
    `playlist`,
    playlistTitle,
    playlistLabel,
    withDefault(dPlaylist ? dPlaylist.thumbnail : ``, defaultThumbnail()).url
  );

  return (
    <>
      <Headers data={ogData} />
      <Page className={composeClassNames([sPageSerie, "page-serie"])}>
        <Header />
        {dPlaylist ? (
          <ValidateContent
            element={`Playlist`}
            blocked={withDefault(dPlaylist.blocked, false)}
            verified={ifDefined(
              dPlaylist.verified,
              (value) => value.verified,
              () => false
            )}
          >
            <PlaylistHead data={dPlaylist} />
            <Content className={`in-detail`} fluid={`xl`}>
              <PlaylistIntroduction data={dPlaylist} />
              {lectures && lectures.length > 0 && (
                <VideoListPlaylist
                  data={mapContentToVideoCards(lectures)}
                  size="lg"
                  type={`class`}
                  title={
                    {
                      serie: translate(`Serie classes`, lang),
                      festival: translate(`Festival classes`, lang),
                    }[dPlaylist.content_type]
                  }
                  showPrivate={dPlaylist.private}
                />
              )}
              <ContentProperties
                className={`border-top`}
                description={dPlaylist.description}
                duration={dPlaylist.duration}
                benefits={dPlaylist.benefits}
                contraindications={dPlaylist.contraindications}
                difficulty={dPlaylist.difficulty}
                practice_styles={dPlaylist.practice_styles}
                practice_skills={dPlaylist.practice_skills}
                practice_body_parts={dPlaylist.practice_body_parts}
                practice_equipments={dPlaylist.practice_equipments}
                practice_focuses={dPlaylist.practice_focuses}
                verified={dPlaylist.verified}
              />
            </Content>
            {/* TODO: more instructors in one lecture are not implemented, implement when is needed */}
            <InstructorHighlight data={dPlaylist.profiles[0]} curator={true} />
          </ValidateContent>
        ) : (
          <Preloader />
        )}
        <Footer />
      </Page>
      <Footers />
    </>
  );
}

/* TODO: make function working for Class, and than make it general = one function for every occurrence */

export const getStaticPaths = async function () {
  const playlists = await fetch(`${constants.Paths.apiUrl}/playlists`).then(
    (res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error("API Error");
      }
    }
  );
  const paths = playlists
    .map((item) => {
      if (!item.slug || !item.locale) {
        return null;
      }
      return { params: { slug: item.slug }, locale: item.locale };
    })
    .filter(Boolean);

  return {
    paths,
    fallback: true,
  };
};

export const getStaticProps = async function ({ params }) {
  const slug = params.slug;
  return {
    props: {
      static: await fetch(`${constants.Paths.apiUrl}/playlists/${slug}`).then(
        (res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("API Error");
          }
        }
      ),
      slug,
    },
  };
};
